module.exports = __webpack_public_path__ + "static/media/piper.c4cc7f09.jpg";